import * as React from 'react';
import styled from 'styled-components';
import UserRow from './UserRow';
import PlanRow from './PlanRow';
import EmailUpdates from './EmailUpdates';
import { PageBack } from '../components/PageBack';
import * as Actions from '../state/actions';

import { storeDispatch } from '../state/Store';
import { confirmAccountDeletion } from '../state/actions';
import { ColorThemesRow } from './ColorThemesRow';
import { CustomFontsRow } from './CustomFontsRow';

const Footer = styled.p`
  opacity: 0.5;
  font-weight: bold;
  font-size: 12px;
  line-height: 16px;
  margin-top: 20px;
`;

const HR = styled.hr`
  border: solid 1px rgba(var(--primary-fg-rgb), 0.1);
  margin: 30px 0;
`;

const Wrapper = styled.div`
  position: relative;
  max-height: calc(100% - var(--top-bar-height));
  overflow: auto;
`;

export const AccountSettings: React.FC = () => {
  // const [isDeletingAccount, setIsDeletingAccount] = React.useState(false);

  const deleteAccount = React.useCallback(() => {
    console.log('Delete account');
    storeDispatch(confirmAccountDeletion());
  }, []);

  React.useEffect(() => {
    storeDispatch({ type: Actions.OPEN_PAGE });
    return () => {
      storeDispatch({ type: Actions.CLOSE_PAGE });
    };
  }, []);

  return (
    <Wrapper>
      <PageBack />
      <div
        style={{
          textAlign: 'center',
          width: 460,
          margin: '0 auto',
          padding: '32px 0'
        }}
      >
        <h1>Account Settings</h1>
        <UserRow />
        <HR />
        <ColorThemesRow />
        <HR />
        <CustomFontsRow />
        <HR />
        <PlanRow />
        <EmailUpdates />
        <HR />
        <div>
          <button className="large disruptive" onClick={deleteAccount}>
            Delete account
          </button>
          <Footer>
            This will also cancel your subscription and unregister you from the
            newsletter.
          </Footer>
        </div>
      </div>
    </Wrapper>
  );
};



// WEBPACK FOOTER //
// ./src/account/index.tsx